export const environment = {
  apiKeyUrl: 'https://key-provider.auth-dev.rhapsody.health',
  clientId: 'bf5c71f0-b197-013d-c384-51a335d8f054162206',
  showDebugTools: true
};
